import { Controller } from "@hotwired/stimulus";
import { MaskInput } from "maska";

// Connects to data-controller="ruby-ui--masked-input"
export default class extends Controller {
  static targets = ["visible", "hidden"];

  connect() {
    this.maskInput = new MaskInput(this.visibleTarget, {
      onMaska: (detail) => {
        this.hiddenTarget.value = detail.unmasked;
      },
    });
  }

  disconnect() {
    this.maskInput?.destroy();
  }
}
